export const getAnimationDurationInSeconds = (event: React.AnimationEvent) => {
  const targetElement = event.target as Element
  const animationDurationString = window.getComputedStyle(targetElement).animationDuration
  const animationDurationInSeconds = Number(animationDurationString.substring(0, animationDurationString.length - 1)) * 1000
  return animationDurationInSeconds
}
